import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { FilterButton } from '@pocketlaw/tetris';
export function FuzzyModifier(props) {
    const { setModifiers, modifiers } = props;
    const toggleFuzzy = () => {
        setModifiers({
            isFuzzy: !modifiers.isFuzzy,
        });
    };
    const enabled = t({ message: 'Enabled', comment: 'Universal search - fuzzy search: Enabled' });
    const disabled = t({ message: 'Disabled', comment: 'Universal search - fuzzy search: Disabled' });
    return (<FilterButton onClick={toggleFuzzy}>
      <b>
        <Trans comment="Universal search - fuzzy search: Title">Approximate Matching</Trans>:
      </b>{' '}
      {modifiers.isFuzzy ? enabled : disabled}
    </FilterButton>);
}
